import { put } from 'redux-saga/effects';
import jsonwebtoken from 'jsonwebtoken';

import api from './../api';
import { loginSuccess, loginFail, userFetch, eventsFetch } from '../actions';

export function* loginSaga(action) {
  try {

    const loginData = yield {
      ...action.payload,
      service: 'f5c60e268955e61a072ff3ab545f2411e349b09c177dc97aa050c435d75b148c'
    };

    const response = yield api.auth.login(loginData);

    if(!response.data.data.token) {
      const customError = {
        code: 0,
        title: 'Connection error',
        details: 'There seems to be a problem with the server. Try again later.'
      };
      throw customError;
    }


    // Set token to localStorage
    const token = yield response.data.data.token;
    const decodedToken = jsonwebtoken.decode(token);

    localStorage.setItem('token', token);

    yield put(userFetch(decodedToken.userID));
    yield put(eventsFetch(decodedToken.userID));
    yield put(loginSuccess({payload: decodedToken}));

  } catch (response) {

    // Parse response errors
    let { firstError, errors } = yield response;
    if(!firstError && response.title && response.details) {
      firstError = response;
      errors = [response]
    }

    localStorage.removeItem('token');

    yield put(loginFail({error: firstError, errors}));
  }
}
